<style lang="scss" scoped>
.page_header {
  .button {
    padding: 0.35rem 0.75rem;
    height: 2rem;
  }

  .icon.is-small .mdi {
    font-size: 16px;
  }
}

.receipt_details .bill_tables .footer_table .table.leftside tr td[data-v-ac24c7a6]:nth-child(1) {
  width: 0;
}

.button.has-text-info {
  width: auto !important;
}

.msg_div {
  width: auto !important;
}

.modal_table {
  table,
  th,
  td {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    padding: 0.65rem 0.7rem;
    font-size: 1rem;
  }

  table {
    overflow-x: scroll;
    overflow-y: scroll;
  }

  td {
    display: table-cell;
    padding: 5px;
    color: black;
  }

  th {
    color: #fff;
    background-color: #56509f;
  }
}

.receipt_details {
  .receipt_heading {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .sub_headings {
    color: seagreen;
  }

  .title.is-5 {
    color: black;
  }

  .hr_yellow {
    background-color: #191d38;
    height: 0.3rem;
  }

  .border_dashed {
    border-left: 1px dashed gray;
  }

  .customer_details,
  .franchisee_details {
    th {
      width: 10rem;
    }

    .table td,
    .table th {
      border: 0;
      padding: 0.3em 0.75em;
    }
  }

  .bill_tables {
    .table th {
      border: 1px solid #9a9a9a;
      background-color: #191d38;
      color: white;
      padding: 0.8em 0.75em;
    }

    .table td {
      padding: 0.8em 0.75em;
      border: 0.5px solid #9a9a9a;
    }

    caption {
      padding: 0.75rem;
      font-size: 1rem;
    }

    .footer_table {
      padding: 0 !important;

      .table td {
        padding: 0.25rem 0.4rem;
        border: 1px lightcyan;
      }

      .table.rightside tr {
        td {
          text-align: right;
        }
      }

      .table.leftside tr {
        // td:nth-child(1) {
        //   width: 12rem;
        // }
        td:nth-child(2) {
          padding-left: 1.5rem;
          width: 5rem;
        }
      }
    }
  }
}
</style>
<template>
  <section>
    <div class="box wrapper">
      <div class="page_header">
        <div class="level m-b-15">
          <div class="level-left">
            <div class="level-item">
              <h5 class="title is-5">Order Details &nbsp;</h5>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item" v-if="orderData.status === orderStatus.pending && changeAddressAccess">
              <button class="button is-success is-small" title="Change Shipping address" @click="getAllPendingOrders()">
                <b-icon icon="map-marker-plus" size="is-small" class="m-r-5"></b-icon>
                Change Address
              </button>
            </div>
            <div
              class="level-item"
              v-if="
                orderData.status === this.orderStatus.shipped ||
                orderData.status === this.orderStatus.delivered
              "
            >
              <button
                class="button is-success is-small"
                title="Consolidated Invoice"
                @click="consolidatedInvoice()"
              >
                <b-icon icon="printer" size="is-small" class="m-r-5"></b-icon>
                Consolidated Invoice
              </button>
            </div>
            <div class="level-item" v-if="placeDamagedOrder && damagedOrderAccess">
              <button class="button is-danger is-small" title="Reorder Missing products " @click="damageReorder('ReorderMissingProducts')">
                <b-icon icon="image-broken-variant" size="is-small" class="m-r-5"></b-icon>
                Missing Products Reorder
              </button>
            </div>
            <div class="level-item" v-if="placeDamagedOrder && damagedOrderAccess">
              <button class="button is-danger is-small" title="Damaged Products" @click="damageReorder(`ReorderDamagedProducts`)">
                <b-icon icon="image-broken" size="is-small" class="m-r-5"></b-icon>
                Re-Order
              </button>
            </div>
            <div class="level-item" v-if="damagedProductAlreadyOrdered && damagedOrderAccess">
              <router-link
                :to="{
                  name: 'KitOrderDetails',
                  params: {
                    kitType: damagedOrder.kitType,
                    orderID: damagedOrder.damagedOrderID,
                    status: damagedOrder.damagedOrderID.status,
                    previousKitType: kitType,
                    previousOrderID: invoiceDetail.orderID,
                    previousOrderStatus: status
                  }
                }"
                class="button is-danger is-small"
                title="View Damaged/Missing Order"
                ><span class="mdi mdi-eye-outline mdi-18px m-r-5"></span>
                Damaged/Missing
              </router-link>
            </div>

            <div class="level-item" v-show="orderData.status === this.orderStatus.fail">
              <button class="button is-link is-small" title="Re-Order" @click="placeOrder()">
                <b-icon icon="cart-outline" size="is-small" class="m-r-5"></b-icon>
                Re-order
              </button>
            </div>
            <div class="level-item" v-show="orderData.status === this.orderStatus.shipped || orderData.status === this.orderStatus.delivered">
              <button class="button is-link is-small" title="Print" @click="printInvoice()">
                <b-icon icon="printer" size="is-small" class="m-r-5"></b-icon>
                PRINT
              </button>
            </div>
            <div class="level-item">
              <router-link
                v-if="!franchiseeID && previousKitType && previousOrderID"
                :to="{ name: 'KitOrderDetails', params: { kitType: previousKitType, orderID: previousOrderID, status: previousOrderStatus } }"
                class="button is-small is-link"
                >Back to List</router-link
              >
              <router-link v-if="!franchiseeID && !previousKitType && !previousOrderID" :to="{ name: 'KitOrderHistory', params: { kitType } }" class="button is-small is-link"
                >Back to List</router-link
              >
              <router-link v-if="franchiseeID" :to="{ name: 'ledgerDetail', params: { franchiseeID } }" class="button is-small is-link">Back to List</router-link>
            </div>
          </div>
        </div>

        <hr class="m-t-0 m-b-20" />
        <div class="columns">
          <div class="column is-one-third customer_details p-t-10  m-l-15">
            <template v-if="studentDetails">
              <table class="table is-fullwidth m-b-10 p-l-15">
                <tr v-if="studentDetails.studentEnrollment != null">
                  <th>Name :</th>
                  <td>{{ studentDetails.studentEnrollment.studentName || '-' }}</td>
                </tr>
                <tr v-if="studentDetails.studentEnrollment != null ? false : true">
                  <th>Name :</th>
                  <td>{{ studentDetails.studentFirstName || '-' }}</td>
                </tr>

                <tr v-if="studentDetails.studentEnrollment != null ? true : false">
                  <th>Enrollment Code:</th>
                  <td>
                    {{ studentDetails.studentEnrollment.enrollmentCode || '-' }}
                  </td>
                </tr>
                <tr v-if="studentDetails.studentEnrollment != null ? false : true">
                  <th>Enrollment Code:</th>
                  <td>
                    {{ studentDetails.enrollmentCode || '-' }}
                  </td>
                </tr>
                <tr v-show="studentDetails.studentEnrollment != null ? true : false" v-if="studentDetails.studentEnrollment != null ? true : false">
                  <th>MCB Enrollment :</th>
                  <td>
                    {{ studentDetails.studentEnrollment.enrollmentNoMCB || '-' }}
                  </td>
                </tr>
                <tr v-show="studentDetails.studentEnrollment != null ? false : true" v-if="studentDetails.studentEnrollment != null ? false : true">
                  <th>Enquiry Code:</th>
                  <td>
                    {{ studentDetails.enquiryCode || '-' }}
                  </td>
                </tr>
              </table>
            </template>
          </div>

          <div class="column"></div>
          <div class="column ">
            <div class="column is-two-fifths customer_details p-t-10  m-l-5">
              <table class="table is-fullwidth m-b-10 p-l-20">
                <tr>
                  <th>
                    <b-tag type="is-light" size="is-medium">Order status</b-tag>
                  </th>
                  <td>
                    <b-tag type="is-primary" size="is-medium">{{ orderData.status }}</b-tag>
                  </td>
                </tr>

                <tr>
                  <th>
                    <b-tag type="is-light" size="is-medium">Class Name</b-tag>
                  </th>
                  <td>
                    <b-tag type="is-primary" size="is-medium ">
                      {{
                        orderData.kit
                          ? orderData.kit.studentClass
                            ? orderData.kit.studentClass.name
                            : '-'
                          : orderData.enquiry
                          ? orderData.enquiry.studentClass
                            ? orderData.enquiry.studentClass.name
                            : '-' || '-'
                          : orderData.studentAdmission
                          ? orderData.studentAdmission.class
                          : '-'
                      }}</b-tag
                    >
                  </td>
                </tr>
                <template v-if="studentDetails">
                  <tr v-show="studentDetails.studentEnrollment != null ? false : true" v-if="studentDetails.studentEnrollment != null ? false : true">
                    <th>
                      <b-tag type="is-light" size="is-medium">Application Code</b-tag>
                    </th>
                    <td>
                      <b-tag type="is-primary" size="is-medium ">
                        {{ studentDetails.applicationCode || '-' }}
                      </b-tag>
                    </td>
                  </tr>
                </template>
              </table>
            </div>

            <div></div>
          </div>
        </div>
        <hr class="m-t-0 m-b-20" />
      </div>
      <div class="m-b-40 receipt_details">
        <div class="columns m-b-0">
          <div class="column is-12 p-t-5">
            <div class="heading has-text-centered">
              <h2 class="has-text-black-bis receipt_heading">Cash Memo/Invoice</h2>
            </div>

            <div class="level m-b-5 m-t-5">
              <div class="level-left">
                <div class="level-item">
                  <b class="is-size-6">
                    <span class="m-r-5">Order ID:</span>
                    <span>{{ invoiceDetail.orderID }}</span>
                  </b>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <span> <b class="m-r-5">Date &amp; Time: </b> {{ ordertime }}</span>
                </div>
              </div>
            </div>
            <hr class="m-t-7 hr_yellow" />
          </div>
        </div>
        <div class="columns">
          <div class="column is-6 p-t-0 p-b-0">
            <div class="invoice_details">
              <div class="columns m-b-0">
                <div class="column has-text-left">
                  <span><img src="https://cdn.fcglcdn.com/brainbees/images/n/fc_logo.jpg"/></span>
                </div>
              </div>
              <hr class="m-b-10 m-t-10" />

              <div class="customer_details p-t-10  m-l-15">
                <div class="m-b-10 p-l-10">
                  <h4 class="title is-5"><b>Invoice To</b></h4>
                </div>
                <table class="table is-fullwidth m-b-0">
                  <tr>
                    <th>Franchisee Name :</th>
                    <td>
                      <span>{{ franchisee ? franchisee.companyName : '-' }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Trust Name :</th>
                    <td>{{ franchisee ? franchisee.trustName : '-' }}</td>
                  </tr>
                  <tr>
                    <th>Address :</th>
                    <td>
                      <span>{{ franchisee ? franchisee.address1 : '-' }}</span>
                      <span>&nbsp;{{ franchisee ? franchisee.country : '-' }} -{{ franchisee ? franchisee.pincode : '-' }}</span>
                    </td>
                  </tr>

                  <tr>
                    <th>GST No:</th>
                    <td>{{ franchisee ? franchisee.gstNo : '-' }}</td>
                  </tr>
                  <tr>
                    <th>Contact Person :</th>
                    <td>
                      <span>{{ franchisee ? franchisee.firstname : '-' }}</span> &nbsp;
                      <span>{{ franchisee ? franchisee.lastname : '-' }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Mobile No :</th>
                    <td>
                      <span style="margin-right: 40px;">{{ franchisee ? franchisee.mobileno : '-' }}</span>
                      <span style="font-weight: bold; margin-right: 20px;">Business Partner’s Mobile No. :</span>
                      <span>{{ franchisee ? franchisee.businessPartnerMobileno : '-' }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Email id :</th>
                    <td>
                      <span>{{ franchisee ? franchisee.email : '-' }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="column is-6 m-l-15 p-l-30 p-r-30 p-b-0 p-t-0 border_dashed">
            <div class="franchisee_details">
              <div class="m-b-10 p-l-10">
                <h4 class="title is-5">
                  <b>{{ invoiceDetail.companyName }}</b
                  ><br />
                  <b>{{ warehoseDetail.WareHouseName }}</b>
                </h4>
              </div>
              <table class="table is-fullwidth m-b-0">
                <tr>
                  <th>GST No :</th>
                  <td>{{ warehoseDetail.GSTNo }}</td>
                </tr>
                <tr>
                  <th>Contact No.</th>
                  <td>{{ warehoseDetail.ContactNo }}</td>
                </tr>

                <tr>
                  <th>Address :</th>
                  <td>
                    {{ warehoseDetail.WareHouseAddress }}-{{ warehoseDetail.PinCode }}({{ warehoseDetail.WareHouseCity }})
                    {{ warehoseDetail.WareHouseState }}
                  </td>
                </tr>
                <!-- <tr>
                  <th>Email ID :</th>
                  <td>-</td>
                </tr> -->
              </table>

              <div class="m-b-10 p-l-10">
                <h4 class="title is-5">
                  <b>Shipping Address</b>
                </h4>
              </div>
              <table class="table is-fullwidth m-b-0">
                <tr>
                  <th>Ship to :</th>
                  <td>
                    {{ this.orderData.orderShippingDetail ? this.orderData.orderShippingDetail.firstname : '-' }}
                  </td>
                </tr>
                <tr>
                  <th>Contact No.</th>
                  <td>
                    {{ this.orderData.orderShippingDetail ? this.orderData.orderShippingDetail.mobileNumber : '-' }}
                  </td>
                </tr>

                <tr>
                  <th>Address :</th>
                  <td>
                    {{ this.invoiceDetail.shippingAddress }}
                  </td>
                </tr>
                <!-- <tr>
                  <th>Email ID :</th>
                  <td>-</td>
                </tr> -->
              </table>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item"  v-if="
            (isBp || isSuperAdmin) &&
            (
              orderData.status === this.orderStatus.shipped ||
              orderData.status === this.orderStatus.delivered
            )
            ">
            <button
              class="button is-success is-small"
              title="Create Ticket"
              :disabled="!isTicketCreatable"
              @click="createTicket()"
            >
              <b-icon icon="printer" size="is-small" class="m-r-5"></b-icon>
              Create Ticket
            </button>
          </div>
        </div>
        <div class="bill_tables ">
          <hr />
          <table class="table is-narrow is-fullwidth is-bordered">
            <thead>
              <tr>
                <th v-if="(isBp || isSuperAdmin) &&
                  (
                    orderData?.status === orderStatus.shipped ||
                    orderData?.status === orderStatus.delivered
                  )">
                  <v-checkbox
                    v-model="selectAllFCIDs" @change="toggleAll"
                    :indeterminate="isIndeterminate" hide-detailsdense
                  >
                  </v-checkbox>
                </th>
                <th class="has-text-left">FC ID</th>
                <th class="has-text-left">Particulars/HSN</th>
                <th class="has-text-right">MRP (<small class="rupeeSign">&#x20b9;</small>)</th>
                <th class="has-text-right">Qty</th>
                <th class="has-text-right" v-if="invoiceDetail.displayIGST">IGST( <b-icon icon="percent" size="is-small"></b-icon>)</th>
                <th class="has-text-right" v-if="!invoiceDetail.displayIGST">CGST ( <b-icon icon="percent" size="is-small"> </b-icon>)</th>
                <th class="has-text-right" v-if="!invoiceDetail.displayIGST">SGST ( <b-icon icon="percent" size="is-small"></b-icon>)</th>
                <th class="has-text-right">Discount (<small class="rupeeSign">&#x20b9;</small>)</th>
                <th class="has-text-right">Value (Incl.Tax)(<small class="rupeeSign">&#x20b9;</small>)</th>
                <th class="has-text-left" v-if="(isBp || isSuperAdmin) &&
                  (
                    orderData?.status === orderStatus.shipped ||
                    orderData?.status === orderStatus.delivered
                  )">
                  Reason
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="o in orderDetails" :key="o.id">
                <td v-if="(isBp || isSuperAdmin) &&
                  (
                    orderData?.status === orderStatus.shipped ||
                    orderData?.status === orderStatus.delivered
                  )">
                  <v-checkbox
                    v-model="o.checked"
                    @change="updateSelectAllState"
                    hide-details
                    dense
                  ></v-checkbox>
                </td>
                <td class="has-text-left">{{ o.productid }}&nbsp;</td>
                <td align="left">
                  <small
                    >{{ o.name }}&nbsp;
                    <span>(HSN Code-{{ o.HSNCode }})</span>
                  </small>
                </td>
                <td class="has-text-right">{{ o.mrp | decimal(o.mrp) }}</td>
                <td class="has-text-right">{{ o.quantity }}</td>
                <td class="has-text-right" v-if="invoiceDetail.displayIGST">{{ o.IGST }}</td>
                <td class="has-text-right" v-if="!invoiceDetail.displayIGST">{{ o.CGST }}</td>
                <td class="has-text-right" v-if="!invoiceDetail.displayIGST">{{ o.SGST }}</td>
                <td class="has-text-right">{{ o.discount | decimal(o.discount) }}</td>
                <td class="has-text-right">{{ o.totalPrice | decimal(o.totalPrice) }}</td>
                <td class="has-text-right" v-if="(isBp || isSuperAdmin) &&
                  (
                    orderData?.status === orderStatus.shipped ||
                    orderData?.status === orderStatus.delivered
                  )">
                  <v-autocomplete
                    :items="reasonList"
                    v-model="o.selectedReason"
                    item-text="label"
                    item-value="id"
                    label="Reason type"
                  >
                  </v-autocomplete>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" class="footer_table ">
                  <table class="table leftside m-b-0">
                    <tr>
                      <td>Total Items:</td>
                      <td style="text-align: left">{{ orderData.totalItems }}</td>
                    </tr>
                    <tr>
                      <td>Total Qty:</td>
                      <td style="text-align: left">{{ orderData.totalQuantity }}</td>
                    </tr>
                  </table>
                </td>

                <td colspan="8" class="footer_table">
                  <table class="table rightside is-fullwidth m-b-0">
                    <tr v-if="invoiceDetail.displayIGST">
                      <td>IGST:(<small class="rupeeSign">&#x20b9;</small>)</td>
                      <td>{{ Number(totalIGSTAmount).toFixed(2) }}</td>
                    </tr>

                    <tr v-if="!invoiceDetail.displayIGST">
                      <td>CGST:(<small class="rupeeSign">&#x20b9;</small>)</td>
                      <td>{{ Number(totalCGSTAmount).toFixed(2) }}</td>
                    </tr>

                    <tr v-if="!invoiceDetail.displayIGST">
                      <td>SGST:(<small class="rupeeSign">&#x20b9;</small>)</td>
                      <td>{{ Number(totalSGSTAmount).toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td>Total Discount: (<small class="rupeeSign">&#x20b9;</small>)</td>
                      <td>{{ invoiceDetail.totalDiscounts | decimal(invoiceDetail.totalDiscounts) }}</td>
                    </tr>

                    <tr>
                      <td>Total Amount(Including Tax): (<small class="rupeeSign">&#x20b9;</small>)</td>
                      <td>{{ orderData.netPayment | decimal(orderData.netPayment) }}</td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Grand Total: (<small class="rupeeSign">&#x20b9;</small>)</strong>
                      </td>
                      <td>
                        <strong>{{ orderData.netPayment | decimal(orderData.netPayment) }}</strong>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tfoot>
          </table>
          <div v-if="invoiceDetail.image" style="text-align:center;">
            <img v-bind:src="invoiceDetail.image" />
          </div>
          <!-- Tax details table-->
        </div>
      </div>
      <div class="" v-if="franchisee && invoiceDetail.products.length">
        <OrderInvoice :invoiceDetail="invoiceDetail" :franchisee="franchisee" />
      </div>
    </div>
    <div class="modal" :class="{ 'is-active': isActiveDamagedProductReorder }">
      <div class="modal-background"></div>
      <form class="modal-card" style="width:45rem;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <strong> Damaged/Missing Products Order - {{ orderID }} </strong>
          </p>
          <button class="delete" type="button" @click.prevent="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="placeDamagedProductsOrder()">
            <div class="field">
              <div class="columns text-is-centered">
                <div class="column">
                  <b-field>
                    <b-upload v-model="dropFiles" @input="csvToJsonInput(dropFiles)" accept=".csv" single drag-drop title="Please do upload .csv file only">
                      <section class="section">
                        <div class="content has-text-centered" expanded>
                          <p>
                            <b-icon icon="upload" size="is-large"> </b-icon>
                          </p>
                          <p>Drop your file here or click to upload</p>
                        </div>
                      </section>
                    </b-upload>
                  </b-field>
                  <div class="tags">
                    <span v-if="dropFiles" class="tag is-primary">
                      {{ dropFiles.name }}
                      <button class="delete is-small" type="button" @click="deleteDropFile()"></button>
                    </span>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <b-field label="Description">
                      <b-input type="is-success" placeholder="Description" :autofocus="true" v-model="damagedReorderDetails.description"></b-input>
                    </b-field>
                  </div>
                  <div class="field" v-if="jsonData.length > 0">
                    <p>
                      <b>Total:- {{ jsonData.length }}</b>
                    </p>
                    <hr />
                  </div>
                  <div class="field">
                    <div class="columns">
                      <div class="column has-text-centered">
                        <button class="button is-info m-r-10" type="submit" @click.prevent="placeDamagedProductsOrder()">Place Order</button>
                      </div>
                      <div class="column has-text-centered">
                        <a class="button is-link" type="is-success" href="https://intellitots.s3.ap-south-1.amazonaws.com/DamagedProducts.csv" download>Download dummy file</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns is-mobile">
              <div class="column" v-if="jsonData.length > 0" style="overflow-x:scroll;">
                <table class="modal_table">
                  <thead>
                    <th class="text-is-centered" v-for="head in Object.keys(jsonData[0])" :key="head">
                      {{ head }}
                    </th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in jsonData" :key="index">
                      <td v-for="(data, head) in row" :key="head">
                        {{ data ? data.toString() : '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </form>
        </section>
      </form>
    </div>

    <div class="modal" :class="{ 'is-active': isChangeAddress }">
      <div class="modal-background"></div>
      <form class="modal-card" style="width:45rem;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <strong> Change Shipping Address -{{ this.orderID }}</strong>
          </p>
          <button class="delete" type="button" @click.prevent="closeAddressModal()"></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="changeShippingAddress()">
            <div class="field">
              <div class="columns">
                <div class="column">
                  <label class="label">Shipping To</label>
                  <p class="control">
                    <input class="input" type="text" maxlength="50" pattern="[A-Za-z ]{1,50}" required v-model="orderShippingDetail.firstName" placeholder="Shipping To" />
                  </p>
                </div>
                <div class="column">
                  <label class="label">Shipping Mobile No</label>
                  <p class="control">
                    <input
                      class="input"
                      type="text"
                      maxlength="10"
                      pattern="[6789]\d{9}$"
                      title="Enter 10 digit mobile number"
                      required
                      v-model="orderShippingDetail.mobileNumber"
                      placeholder="Mobile Number"
                    />
                  </p>
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label">Address</label>
              <b-input maxlength="150" type="textarea" v-model="orderShippingDetail.address1" required></b-input>
            </div>
            <div class="field">
              <div class="columns">
                <div class="column">
                  <label class="label">State</label>
                  <p class="control">
                    <input class="input" type="text" maxlength="30" pattern="[A-Za-z ]{1,30}" required v-model="orderShippingDetail.state" placeholder="Enter state" />
                  </p>
                </div>
                <div class="column">
                  <label class="label">City</label>
                  <p class="control">
                    <input class="input" type="text" maxlength="25" pattern="[A-Za-z ]{1,30}" required v-model="orderShippingDetail.city" placeholder="Enter City" />
                  </p>
                </div>
                <div class="column">
                  <label class="label">Pincode</label>
                  <p class="control">
                    <input class="input" type="number" required min="100000" max="999999" v-model="orderShippingDetail.pincode" placeholder="Enter pincode" />
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div class="field" v-if="pendindOrders.length">
              <div class="columns is-multiline">
                <div class="column is-4">
                  <label class="label">Apply address changes to</label>
                </div>
                <div class="column is-4">
                  <b-checkbox v-model="selectAll" :indeterminate="selectedOrders.length > 0 && selectedOrders.length < pendindOrders.length" @input="selectAllOrders()">
                    Select All
                  </b-checkbox>
                </div>
              </div>
              <div class="columns is-multiline">
                <div class="column is-4" v-for="order in pendindOrders" :key="order.orderID">
                  <b-checkbox :native-value="order" v-model="selectedOrders" @input="selectOrderId()">
                    {{ order }}
                  </b-checkbox>
                </div>
              </div>
            </div>
            <footer class="modal-card-foot">
              <button class="button" type="button" @click.prevent="closeAddressModal()">Cancel</button>
              <button class="button is-info" type="submit">Change Address</button>
            </footer>
          </form>
        </section>
      </form>
    </div>
  </section>
</template>
<script src="/build/qrcode.min.js"></script>
<script lang="en">
import moment from 'moment'
import QRCode from 'qrcode'
// @ is an alias to /src
// import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import helper from '@/utils/helper'
import OrderInvoice from '@/components/OrderInvoice'
import Utils from '@/utils'
import stores from '@/stores'
import csvtojsonV2 from 'csvtojson'
import _ from 'lodash'

export default {
  filters: {
    decimal: function (value) {
      return Number(value).toFixed(2)
    }
  },
  name: 'orderDetails',
  props: ['kitType', 'orderID', 'status', 'franchiseeID', 'previousKitType', 'previousOrderID', 'previousOrderStatus'],
  components: {
    OrderInvoice

  },
  computed: {
  },
  data () {
    return {
      studentName: '',
      isServeacible: false,
      enrollmentCode: '',
      isMenuNavBarActive: false,
      damagedOrderAccess: this.checkModuleAccess('DamagedMissingOrder'),
      changeAddressAccess: this.checkModuleAccess('ShippingAddressUpdate'),
      placeDamagedOrder: false,
      damagedProductAlreadyOrdered: false,
      damageOrderType:null,
      isActiveDamagedProductReorder: false,
      isChangeAddress: false,
      orderShippingDetail: {
        firstName: '',
        mobileNumber: '',
        address1: '',
        state: '',
        city: '',
        pincode: ''
      },
      currentAcademicYearID: null,
      selectedOrders: [],
      selectAll: false,
      isNavBarVisible: false,
      data: [],
      totalSGSTAmount: '',
      totalCGSTAmount: '',
      ordertime: '',
      total: '',
      order: 'is-right',
      isLoading: false,
      paginated: false,
      perPage: 10,
      pendindOrders: [],
      checkedRows: [],
      billingDetails: [],
      studentDetails: '',
      orderData: [],
      orderDetails: [],
      warehoseDetail: [],
      loadingComponent: null,
      franchisee: null,

      dropFiles: null,
      jsonData: [],
      damagedOrder: {
        isDamagedOrderPlaced: false,
        damagedOrderID: '',
        kitType: '',
        status: ''
      },
      damagedReorderDetails: {
        products: [],
        description: ''
      },
      invoiceDetail: {
        orderID: this.$route.params.orderID,
        products: [],
        warehouse: {},
        image: '',
        companyName: constants.companyName,
        currentDate: new Date(),
        grandTotal: 0,
        displayIGST: false,
        totalIGSTAmount: '',
        totalSGSTAmount: '',
        totalCGSTAmount: '',
        shippingAddress: {},
        billingAddress: {}
      },
      orderStatus: {
        pending: constants.ORDER_STATUS.pending,
        fail: constants.ORDER_STATUS.fail,
        shipped: constants.ORDER_STATUS.shipped,
        delivered: constants.ORDER_STATUS.delivered
      },
      selectedReson: null,
      reasonList: [],
      selectedReason: null,
      priorityList: [],
      productShippedReasons: ['Dealy in delivery', 'Damage shipment'],
      productDeliveredReasons : ['Dealy in delivery'],
      queryRelatedToList: [],
      selectAllFCIDs: false,
      isTicketCreatable: false,
      userRoles: stores.user.roles || [],
      createTicketAccessRoles: ['manual_assign_order', 'FRANCHISEE_USER_1', 'TICKET_FRANCHISEE', 'CH_LEVEL1'],// for BP
      isBp: false
    }
  },
  async created () {
    this.isBp = this.checkRoleAccess(this.createTicketAccessRoles)
    await this.onFranchiseeChange()
  },
  watch: {
    $route: async function (to, from) {
      // react to route changes...
      this.placeDamagedOrder = false
      this.damagedProductAlreadyOrdered = false
      await this.onStart()
    }
  },
  computed: {
    isIndeterminate() {
      const checkedCount = this.orderDetails.filter(o => o.checked).length;
      return checkedCount > 0 && checkedCount < this.orderDetails.length;
    },
    isSuperAdmin() {
      return stores.user.me.superAdmin
    }
  },
  methods: {
    checkRoleAccess (roleList) {
      return this.userRoles.some(item => roleList.includes(item.role))
    },
    toggleAll() {
      this.orderDetails.forEach(o => {
        o.checked = this.selectAllFCIDs;
      });
    },
    updateSelectAllState() {
      const total = this.orderDetails.length;
      const checkedCount = this.orderDetails.filter(o => o.checked).length;

      this.selectAllFCIDs = checkedCount === total;
    },
    getQueryRelatedList: async function () {
      try {
        let queryParam = {}
        this.isLoading = true
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryRelatedToList`, queryParam)
        if (res.status === 200) {
          this.priorityList = res.data.priorityList || []
          this.queryRelatedToList= res.data.QueryRelatedTo.data || []
          this.queryRelatedToList = this.queryRelatedToList.filter(item => item.label === 'Logistics')
          if(this.queryRelatedToList.length){
            await this.getQueryTypeList(this.queryRelatedToList[0].id)
          }
        }
      } catch (e) {
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    getQueryTypeList: async function (id) {
      if (id) {
        try {
          let payload = {}
          payload.projectmoduleid = parseInt(id)
          this.isLoading = true
          const res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryTypeList`, payload)
          if (res.status === 200) {
            if (res.data.status) {
              this.reasonList = res.data.data
              if(this.orderData.status === this.orderStatus.shipped){
                this.reasonList = this.reasonList.filter(item => this.productShippedReasons.includes(item.label))
              } else if(this.orderData.status === this.orderStatus.delivered){
                this.reasonList = this.reasonList.filter(item => this.productDeliveredReasons.includes(item.label))
              } else {
                this.reasonList = []
              }
            } else {
              this.reasonList = []
            }
          }
        } catch (e) {
          this.reasonList = []
          this.isLoading = false
        }
      } else {
        this.reasonList = []
        this.isLoading = false
      }
    },
    isWithin72Hours(lastModifiedAt) {
      if(!lastModifiedAt) return false
      const modifiedDate = new Date(lastModifiedAt);
      const now = new Date();

      const diffInMs = now - modifiedDate;

      const hours72InMs = 72 * 60 * 60 * 1000;

      return diffInMs <= hours72InMs;
    },
    createTicket: async function () {
      this.isTicketCreatable = this.isWithin72Hours(this.orderData.lastModifiedAt) &&
        (this.orderData.status === this.orderStatus.shipped ||  this.orderData.status === this.orderStatus.delivered)

      if (this.isTicketCreatable && (this.isBp || this.isSuperAdmin)) {
        let checkedOrders = this.orderDetails.filter(o => o.checked);
        if(checkedOrders.length === 0) {
          return this.$dialog.error({
            title: 'Error',
            text: 'Please select at least one FC ID to create ticket.'
          });
        }

        let hasEmptyReason = checkedOrders.some(o => !o.selectedReason);
        if (hasEmptyReason) {
          return this.$dialog.error({
            title: 'Error',
            text: 'Please provide a reason for all selected FC IDs.'
          });
        }

        let damageShipmentOrders = checkedOrders.filter(o => {
          const damageReason = this.reasonList.find(item => item.label === 'Damage shipment');
          return o.selectedReason && damageReason && o.selectedReason === damageReason.id;
        });

        let delayInShipmentOrders = checkedOrders.filter(o => {
          const delayReason = this.reasonList.find(item => item.label === 'Dealy in delivery');
          return o.selectedReason && delayReason && o.selectedReason === delayReason.id;
        });

        this.$buefy.dialog.confirm({
          message: 'Are you sure you want to raise this ticket?',
          onConfirm: async () => {
            try {
              const promises = [];
              if (damageShipmentOrders.length > 0) {
                await this.createTicketAccordingToReason(damageShipmentOrders)
              }
              if (delayInShipmentOrders.length > 0) {
                await this.createTicketAccordingToReason(delayInShipmentOrders);
              }

            } catch (e) {
              const errorMessage =
                (e && e.response && e.response.data.message) || e.message
              return this.$dialog.error({
                text: errorMessage,
                title: 'Error'
              })
            }
          }
        })
      }
    },
    async createTicketAccordingToReason(ordersList) {
      let formData = new FormData()
      let franchiseeName = ''
      let fr_details = null
      let description = ''
      let subject = ''
      let priority = ''
      let querytypeId = ordersList[0].selectedReason
      let mediumPriority = this.priorityList.find(item => item.name === 'Moderate')
      let priorityID = mediumPriority ? mediumPriority.id : null
      let priorityName = mediumPriority ? 'Medium' : ''
      let orderID = this.orderData ? this.orderData.orderID : ''
      if (this.orderData.franchisee && this.orderData.franchisee.id) {
        fr_details = this.orderData.franchisee
        const idPadded = `(${fr_details.id.toString().padStart(3, '0')})`;
        franchiseeName = `${idPadded} ${fr_details.companyName}`;

        if (fr_details.region) {
          franchiseeName = `${franchiseeName} (${fr_details.region})`;
        }
      }

      if (this.queryRelatedToList.length) {
        formData.append('queryRelatedToID', this.queryRelatedToList[0].id)
        let queryTypeName = this.reasonList.find(item => item.id === querytypeId)
        let productIDArr = ordersList.map(item => item.productid).join(',')
        if(queryTypeName.label === 'Damage shipment'){
          subject = `${this.queryRelatedToList[0].label} > ${queryTypeName.label} - ${productIDArr}`
          description = `Shipment received in damaged/defective condition. Order Id: ${orderID} and Products: ${productIDArr}`
        } else {
          //Dealy in delivery
          subject = `${this.queryRelatedToList[0].label} > ${queryTypeName.label} - ${productIDArr}`
          description = `Shipment not delivered within committed timeline. Order Id: ${orderID} and Products: ${productIDArr}`
        }
      }
      if (fr_details) {
        formData.append('franchiseeID', parseInt(fr_details.id))
      }
      formData.append('franchiseeName', franchiseeName)
      formData.append('description', description)
      formData.append('subject', subject)
      formData.append('queryTypeID', querytypeId)
      formData.append('priority', priorityName)

      let currentDate = new Date()
      currentDate.setHours(currentDate.getHours() + 48)
      let ticketEndDate = currentDate.toISOString().split('T')[0]

      if (ticketEndDate) formData.append('endDate', ticketEndDate)
      if (priorityID) formData.append('priorityID', priorityID)
      if (fr_details && fr_details.region) formData.append('zone', fr_details.region)

      try {
        const res = await http.post(
          `${constants.API_URL}/api/sbTicketing/createTicket`,
          formData
        )
        if (res.status === 200 && res.data.status) {
          this.$dialog.info({
            text: 'Ticket created successfully. <br /> Our team will be with you shortly.',
            title: 'Success'
          })
        } else {
          return this.$dialog.error({
            text: res.data.msg,
            title: 'Error'
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    onStart: async function () {
      this.invoiceDetail.orderID = this.$route.params.orderID
      document.title = this.orderID
      await this.getOrderDetails()
      await this.getFranchiseeDetail()
      if (this.orderData.status === 'FAIL') {
        this.$buefy.dialog.alert({
          message: 'Order has been cancelled please Re-order',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        await this.onStart()

        this.inProgress = false
      }
    },
    getQRCode: async function (QRString) {
      try {
         let opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          scale: '2',
          quality: 0.4,
          margin: 1,
          // color: {
          //   dark: '#010599FF',
          //   light: '#FFBF60FF'
          // }
        }

       await QRCode.toDataURL(
          QRString,

        )
          .then(url => {
            this.invoiceDetail.image = url
            console.log(url)
          })
          .catch(err => {
            console.error(err)
          })
      } catch (e) {
        console.log(e)
      }

    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getTag (status) {
      return helper.getClass(status)
    },
    damageReorder: async function (damageOrderType) {
      let {
        message,
        isActive
      } = await this.getShippingAddress()
      if (!isActive) {
        return this.$buefy.dialog.alert({
          active: isActive,
          title: 'Error',
          message: message || 'Error occured while getting shipping address',
          hasIcon: true,
          type: 'is-danger',
          icon: 'times-circle',
          iconPack: 'fa',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      this.$buefy.dialog.confirm({
        active: isActive,
        title: 'Confirm Address',
        message: message,
        confirmText: 'Proceed',
        cancelText: 'Cancel',
        type: 'is-success',
        hasIcon: true,
        onConfirm: async () => {
          this.damageOrderType=damageOrderType
          this.isActiveDamagedProductReorder = true
        }
      })
    },
    placeOrder: function () {
      this.$buefy.dialog.confirm({
        title: 'Confirm Order',
        message: 'Are you sure you want to place this order?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            let {
              message,
              isActive
            } = await this.getShippingAddress()
            if (!isActive) {
              return this.$buefy.dialog.alert({
                active: isActive,
                title: 'Error',
                message: message || 'Error occured while getting shipping address',
                hasIcon: true,
                type: 'is-danger',
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.$buefy.dialog.confirm({
              active: isActive,
              title: 'Confirm Address',
              message: message,
              confirmText: 'Proceed',
              cancelText: 'Cancel',
              type: 'is-success',
              hasIcon: true,
              onConfirm: async () => {
                try {
                  this.loadingComponent = this.$buefy.loading.open()
                  await http.get(`${constants.API_URL}/api/order/re-order/${this.orderID}`)
                } catch (e) {
                  const errorMessage = (e && e.response && e.response.data.message) || e.message
                  return this.$buefy.dialog.alert({
                    type: 'is-danger',
                    message: errorMessage,
                    hasIcon: true,
                    animation: 'zoom-out',
                    size: 'is-medium',

                    icon: ' mdi-exclamation',
                    iconPack: 'mdi',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                  })
                } finally {
                  this.loadingComponent.close()
                }
                await this.getOrderDetails()
                this.$buefy.dialog.alert({
                  title: 'Reorder success',
                  message: 'Order placed successfully',
                  type: 'is-success',
                  hasIcon: true,
                  animation: 'zoom-out',
                  size: 'is-medium',
                  icon: ' mdi-exclamation',
                  iconPack: 'mdi',
                  ariaRole: 'alertdialog',
                  ariaModal: true
                })
              }
            })
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } finally {
            this.loadingComponent.close()
          }
        }
      })
    },
    getOrderDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/order/details/${this.orderID}`)
        this.orderData = response.data
        console.log('this.orderData--', this.orderData)
         if (this.orderData && this.orderData.qrCode) {
          await this.getQRCode(this.orderData.qrCode)
        }
        if(this.orderData && this.orderData.franchiseeDetails){
          this.franchisee = this.orderData.franchiseeDetails
        }
        this.orderDetails = response.data.orderDetails.map(item => ({
          ...item,
          selectedReason: null,
          checked: false
        }));
        this.billingDetails = response.data.orderBillingDetails
        this.studentDetails = this.orderData.studentAdmission ? this.orderData.studentAdmission : this.orderData.enquiry
        this.currentAcademicYearID = this.studentDetails ? this.studentDetails.academicYearID : null
        this.warehoseDetail = response.data.warehouseDetail != null ? response.data.warehouseDetail : ''
        this.invoiceDetail.shippingAddress = `${this.orderData.orderShippingDetail.address1}
        ${this.orderData.orderShippingDetail.city} ${this.orderData.orderShippingDetail.state}-${this.orderData.orderShippingDetail.pincode}`
        if (response.data.orderDamaged) {
          this.damagedOrder.damagedOrderID = response.data.orderDamaged.damagedOrderID
          this.damagedOrder.status = response.data.orderDamaged.status
          let kitData = _.find(constants.KIT, obj => {
            if (obj.id === response.data.orderDamaged.kitType) {
              return obj.route
            }
          })
          this.damagedOrder.kitType = kitData.route
          this.damagedOrder.isDamagedOrderPlaced = true
        } else {
          this.damagedOrder.isDamagedOrderPlaced = false
        }

        if (
          (this.orderData.status === this.orderStatus.shipped || this.orderData.status === this.orderStatus.delivered) &&
          !this.damagedOrder.isDamagedOrderPlaced &&
          this.kitType !== constants.KIT[3].route &&
          this.kitType !== constants.KIT[3].id
        ) {
          this.placeDamagedOrder = true
          this.damagedProductAlreadyOrdered = false
        } else if (this.damagedOrder.isDamagedOrderPlaced) {
          this.placeDamagedOrder = false
          this.damagedProductAlreadyOrdered = true
        }
        this.ordertime = moment(this.orderData.orderTime).format('MMMM Do YYYY, h:mm:ss a')

        this.total = response.data.count
        this.loadingComponent.close()

        if (this.orderData) {
          if((this.orderData.status === this.orderStatus.shipped ||  this.orderData.status === this.orderStatus.delivered) && (this.isBp || this.isSuperAdmin)){
            await this.getQueryRelatedList();
          }

          this.isTicketCreatable = this.isWithin72Hours(this.orderData.lastModifiedAt) &&
          (this.orderData.status === this.orderStatus.shipped ||  this.orderData.status === this.orderStatus.delivered)
          await this.getFranchiseeDetail(this.orderData.franchiseeDetails)
        }
      } catch (e) {
        this.isTicketCreatable = false;
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFranchiseeDetail: async function (franchiseeData = null) {
      try {
        if(!franchiseeData){
        const {
          data
        } = await http.get(`${constants.API_URL}/api/franchisee/${this.orderData.franchiseeID}`)
        this.franchisee = data
        }
        else{
          this.franchisee = franchiseeData
        }

        this.invoiceDetail.billingAddress = `${this.franchisee.address1}
        ${this.franchisee.country} ${this.franchisee.pincode}`
        this.invoiceDetail.products = this.orderData ? this.orderData.orderDetails : []
        this.invoiceDetail.orderDate = this.orderData.orderTime
        this.invoiceDetail.warehouse = this.orderData.warehouseDetail != null ? this.orderData.warehouseDetail : ''

        if (this.invoiceDetail.warehouse.WareHouseState && this.invoiceDetail.warehouse.WareHouseState.toLowerCase() !== this.franchisee.state.toLowerCase()) {
          this.invoiceDetail.displayIGST = true
        }

        this.invoiceDetail.products.forEach(invoice => {
          invoice.IGST = invoice.IGST ? Number(invoice.IGST) : 0
          invoice.CGST = invoice.IGST ? Number(invoice.IGST) / 2 : 0
          invoice.SGST = invoice.IGST ? Number(invoice.IGST) / 2 : 0

          if (invoice) {
            invoice.baseCost = Number(Number(invoice.actualPrice).toFixed(2))
            if (this.invoiceDetail.displayIGST) {
              invoice.igstAmount = invoice.baseCost - invoice.baseCost /(1+  Number(invoice.IGST / 100))
            } else {
              invoice.cgstAmount = invoice.baseCost - invoice.baseCost /(1+  Number(invoice.CGST / 100))
              invoice.sgstAmount = invoice.baseCost - invoice.baseCost /(1+  Number(invoice.SGST / 100))

            }
          }
        })
        if (this.invoiceDetail.displayIGST) {
          this.totalIGSTAmount = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.igstAmount))
        } else {
          this.totalSGSTAmount = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.cgstAmount))
          this.totalCGSTAmount = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.sgstAmount))
        }
        this.invoiceDetail.totalDiscounts = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.discount))
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('e :', errorMessage)
      }
    },
    printInvoice: async function () {
      if (!this.invoiceDetail.products.length) return
      const printContents = document.getElementById('printableArea').innerHTML
      const documentHead =
        '<!DOCTYPE html><html lang="en"><head><style>@page{margin-top:0px;margin-bottom:0px;}body{margin:0;padding:0;font-family:Consolas,arial;font-size:11px;}.invoiceTable{border:1px solid;box-sizing: border-box;border-collapse: collapse;}.invoiceTable td{border-right:1px solid;border-bottom:1px solid;box-sizing: border-box;vertical-align:top;}.invoiceTable td.noBorder{border:none;}.franchiseeTable{line-height: 1.5}</style></head><body>' +
        printContents +
        '</body></html>'
      const doc = document.getElementById('iframeReceipt').contentWindow.document
      document.title = this.orderID+ ' Invoice';
      doc.open()
      doc.write(documentHead)
      window.frames['iframeReceipt'].focus()
      window.frames['iframeReceipt'].print()
      doc.removeChild(doc.documentElement)
    },
    readerFile: function (file, onLoadCallback) {
      var reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: async function (files) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let self = this
        if (files.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = files

        this.readerFile(file, async e => {
          try {
            self.jsonData = await csvtojsonV2().fromString(e.target.result)
            if (!self.jsonData[0].productID || !self.jsonData[0].quantity) {
              self.jsonData = []
              self.dropFiles = null
              return this.$buefy.dialog.alert({
                type: 'is-danger',
                message: 'Invalid file or data of file!',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
          } catch (e) {
            self.jsonData = ''
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        })
        this.flag = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('e :', errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    deleteDropFile () {
      this.jsonData = []
      this.dropFiles = null
      return this.dropFiles
    },
    closeModal () {
      this.jsonData = []
      this.dropFiles = null
      this.isActiveDamagedProductReorder = false,
      this.damageOrderType=null
      this.getOrderDetails()
    },
    closeAddressModal () {
      this.isChangeAddress = false
      this.selectedOrders = []
      this.selectAll = false
      this.getOrderDetails()
    },
    placeDamagedProductsOrder: async function () {
      try {
        if (!this.jsonData.length) {
          return this.$buefy.toast.open({
            message: 'Please upload file!',
            type: 'is-danger',
            duration: 4000
          })
        }

        this.loadingComponent = this.$buefy.loading.open()
        let isError = false
        let errorMessage = ''
        let i = 0
        for (let product of this.jsonData) {
          ++i
          if (isNaN(product.productID) || isNaN(product.quantity) || Number(product.quantity) <= 0) {
            isError = true
            errorMessage = `Invalid productID or quantity at row no. ${i}`
          } else if (product.quantity % 1 !== 0 || product.productID % 1 !== 0) {
            isError = true
            errorMessage = `productID or quantity should not be fractional number!`
          }
        }
        let productIDArray = _.map(this.jsonData, 'productID')

        // let duplicatesArray = productIDArray.filter((productID, index) => productIDArray.indexOf(productID) !== index)
        let findDuplicates = arr => productIDArray.filter((item, index) => productIDArray.indexOf(item) !== index)
        let duplicatesArray = [...new Set(findDuplicates(productIDArray))]
        if (duplicatesArray.length) {
          isError = true
          errorMessage = `Duplicate productID ${[...new Set(findDuplicates(productIDArray))]}`
        }
        if (!this.jsonData.length || isError) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage || 'Invalid Data',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }

        let finalProductsArray = _.map(this.jsonData, obj => {
          return {
            productID: obj.productID,
            quantity: obj.quantity
          }
        })
        let Data = {
          orderID: this.orderID,
          products: finalProductsArray,
          damageOrderType:this.damageOrderType
        }
        if (this.damagedReorderDetails.description) {
          Data.description = this.damagedReorderDetails.description
        }
        await http.post(`${constants.API_URL}/api/order/reorder-damaged-products`, Data)
        this.jsonData = []
        this.dropFiles = null
        this.loadingComponent.close()
        this.closeModal()
        return this.$buefy.dialog.alert({
          message: 'Damaged/Missing products order placed successfully!',
          type: 'is-success',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error while placing order', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    getShippingAddress: async function () {
      let data = {
        message: null,
        isActive: false
      }
      this.loadingComponent = this.$buefy.loading.open()
      let response = await http.get(`${constants.API_URL}/api/order/get-shipping-address`, {
        params: {
          orderID: this.orderID
        }
      })
      if (!response.data) {
        return data
      }
      // let serviceability = {
      //   data: {}
      // }
      // try {
      //   serviceability = await http.get(`${constants.API_URL}/api/pincode-check/${response.data.shippincode}`)
      // } catch (e) {
      //   console.log('e', e.message)
      //   serviceability.data = e
      // }
      // let pinccodeMessage = null
      // if (serviceability.data.statusCode === 200) {
      //   pinccodeMessage = '<b>Your pincode is serviceable!</b>'
      //   data.isActive = true
      // } else {
      //   pinccodeMessage = `<b>Non serviceable pincode</b>`
      //   data.isActive = false
      // }
      //  pinccodeMessage = '<b>Your pincode is serviceable!</b>'
       data.isActive = true
      data.message = `
      <b>Shipping Address:</b><br/>
        ${response.data.shipfirstname} ${response.data.shipmobileno}<br/>
        ${response.data.shipaddressline1},${response.data.shipcity}
         ${response.data.shipstate} - ${response.data.shippincode}
         <br/><b>Billing Address:</b><br/>
         ${this.invoiceDetail.billingAddress}`

      this.loadingComponent.close()
      return data
    },
    // Get All releavant pending orders of student
    getAllPendingOrders: async function () {
      try {
        let data = {
          orderID: this.orderID
        }

        this.loadingComponent = this.$buefy.loading.open()
        let allOrdres = await http.get(`${constants.API_URL}/api/order/get-order-by-status`, {
          params: data })
        if (allOrdres.data && allOrdres.data.length) {
          this.pendindOrders = allOrdres.data.filter(obj => obj.orderID !== this.orderID).map(obj => obj.orderID)
        }
        // Get Latest Shipping Address of student
        let response = await http.get(`${constants.API_URL}/api/order/get-shipping-address`, {
          params: {
            orderID: this.orderID
          }
        })

        if (response) {
          this.orderShippingDetail.firstName = response.data.shipfirstname
          this.orderShippingDetail.mobileNumber = response.data.shipmobileno
          this.orderShippingDetail.address1 = response.data.shipaddressline1
          this.orderShippingDetail.state = response.data.shipstate
          this.orderShippingDetail.city = response.data.shipcity
          this.orderShippingDetail.pincode = response.data.shippincode
        }
        this.isChangeAddress = !this.isChangeAddress

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        console.log(e)
      }
    },
    // Function to Select All orders
    selectAllOrders: function () {
      try {
        // Select all orders
        if (this.selectAll) {
          this.selectedOrders = []
          this.selectedOrders = this.pendindOrders
        } else {
          // Deselect all ordres
          this.selectedOrders = []
        }
      } catch (e) {
        console.log(e)
      }
    },
    // Select order operation
    selectOrderId: function () {
      // If all orders selected enble selectAll checkbox
      if (this.selectedOrders.length === this.pendindOrders.length) {
        this.selectAll = true
        this.selectAllOrders()
      } else {
        // unselect selectAll checkbox
        this.selectAll = false
      }
    },
    // Change Shipping address of orders
    changeShippingAddress: async function () {
      try {
        let message = ''
        let type = ''
        this.loadingComponent = this.$buefy.loading.open()
        let serviceability = {
          data: {}
        }
        if (!this.orderShippingDetail.firstName.trim()) {
          this.loadingComponent.close()
          return this.$buefy.toast.open({
            type: 'is-danger',
            duration: 4000,
            message: 'Please add proper Ship to name!'
          })
        }

        if (!this.orderShippingDetail.address1.trim()) {
          this.loadingComponent.close()
          return this.$buefy.toast.open({
            type: 'is-danger',
            duration: 4000,
            message: 'Please add proper address!'
          })
        }
        if (!this.orderShippingDetail.state.trim()) {
          this.loadingComponent.close()
          return this.$buefy.toast.open({
            type: 'is-danger',
            duration: 4000,
            message: 'Please add proper state!'
          })
        }
        if (!this.orderShippingDetail.city.trim()) {
          this.loadingComponent.close()
          return this.$buefy.toast.open({
            type: 'is-danger',
            duration: 4000,
            message: 'Please add proper city!'
          })
        }
        // Check Serviceability of changes address pincode
        // try {
        //   serviceability = await http.get(`${constants.API_URL}/api/pincode-check/${this.orderShippingDetail.pincode}`)
        // } catch (e) {
        //   serviceability.data = e
        // }
        // if (serviceability.data.statusCode === 200) {
          let payload = {
            shippingAddress: this.orderShippingDetail
          }
          payload.ordersArray = []
          if (this.selectedOrders.length) {
            payload.ordersArray = this.selectedOrders.slice()
          }
          payload.ordersArray.push(this.orderID)
          payload.ordersArray = _.uniq(payload.ordersArray)
          await http.post(`${constants.API_URL}/api/order/update-shipping-address`, payload)
          message = 'Shipping address updated successfully!'
          type = 'is-success'
          this.loadingComponent.close()
          this.closeAddressModal()
        // } else {
        //   this.loadingComponent.close()
        //   message = 'Your Pincode is not serviceable!<br/>Please Check Address!'
        //   type = 'is-danger'
        // }

        return this.$buefy.dialog.alert({
          message: message,
          type: type,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error while updating shipping address ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    consolidatedInvoice: async function () {
     try {
        let response = await http.get(`${constants.API_URL}/api/order/consolidated-invoice/${this.orderID}`)
        console.log('consolidatedInvoice', response.data.invoiceUrl)
        let invoiceUrl = response.data.invoiceUrl
        if(invoiceUrl) {
         window.open(invoiceUrl)
        }
      } catch (e) {
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
  }
}
</script>
